module.exports = __webpack_public_path__ + "Cross/Cross-0120902baef06835638a458f5295ece0.svg";